import {call, put, takeLatest, debounce} from "redux-saga/effects";
import {customerActions} from "./customerSlice";
import {customerApi} from "~/api";

function* fetchDemoList(action) {
	try {
		const response = yield call(customerApi.gets, action.payload);
		yield put(customerActions.fetchDataSuccess(response))
	}
	catch (error) {
		console.log('Failed to fetch customer list', error);
		let message = error.message;
		if(error?.response?.data?.message) message = error.response.data.message;
		yield put(customerActions.fetchDataFailed(message));
	}
}

function* handleSearchDebounce(action) {
	yield put(customerActions.setFilter(action.payload));
}

export default function* customerSaga() {
	yield takeLatest(customerActions.fetchData.type, fetchDemoList);
	yield debounce(500, customerActions.setFilterWithDebounce.type, handleSearchDebounce)
}